
import { ReactElement } from "react";
import { Icon, IconValue } from "client/Components";
import styles from "./InlineIcon.module.less";

export type InlineIconProps = {
	icon: IconValue;
};

export const InlineIcon = (props: InlineIconProps): ReactElement => {
	const {
		icon
	} = props;

	return (
		<span className={styles.root}>
			<Icon value={icon} />
		</span>
	);
};
InlineIcon.displayName="InlineIcon";